'use client';

import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';

import { CardDraftLabel } from '~components/CardDraftLabel/CardDraftLabel';
import ArrowIcon from '~public/static/images/icons/arrows/Arrow_Right_LG.svg';

import styles from './ArticleCardColored.module.scss';
import { ArticleCardWithIconProps } from './ArticleCardColored.types';

export function ArticleCardColored({
  className,
  title,
  categories,
  href,
  publishedAt,
}: ArticleCardWithIconProps) {
  return (
    <article className={classNames(className, styles.card)}>
      {!publishedAt && <CardDraftLabel />}
      <div className={styles.content}>
        <div>
          {categories?.map((category) => (
            <Typography
              tagName={TypographySizes.div}
              mods={[TypographyMods.bodyS]}
              className={styles.category}
              key={category.id}
            >
              {category.title}
            </Typography>
          ))}

          <Typography
            tagName={TypographySizes.h3}
            className={styles.title}
            mods={[TypographyMods.bodyMAlt]}
          >
            {title}
          </Typography>
        </div>
      </div>

      <div className={styles.footer}>
        <Link className={styles.link} href={href}>
          Читать
          <ArrowIcon className={styles.linkIcon} />
        </Link>
      </div>
    </article>
  );
}
